import RestService from '@/modules/backend/RestService';
import { Permission } from '@/modules/backend/Entities/Permission';
import { EditPermissionData } from '@/modules/backend/Dto/EditPermissionData';
import { plainToClass } from 'class-transformer';

export class Permissions {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async List(): Promise<Permission[]> {
    const items = await this.rest.get<unknown[]>('/api/v3/permissions');
    return plainToClass(Permission, items);
  }

  public async Update(data: EditPermissionData): Promise<Permission> {
    const permission = await this.rest.put('/api/v3/permission', data);
    return plainToClass(Permission, permission);
  }
}
